import React from "react";

/**
 * BrandGraphic — clean navy + gold graphic background used in place of stock photography.
 * Variants control the composition (geometric blocks, large logo watermark, gold accent bar).
 */
export const BrandGraphic = ({ variant = "logo", className = "", children }) => {
  if (variant === "logo") {
    return (
      <div className={`relative w-full h-full bg-[#003B5C] overflow-hidden grain-overlay ${className}`}>
        {/* Gold accent corner */}
        <div className="absolute -top-12 -right-12 w-48 h-48 rounded-full bg-[#D4A437]/15" />
        <div className="absolute -bottom-16 -left-16 w-72 h-72 rounded-full bg-[#D4A437]/10" />
        {/* Large logo watermark */}
        <div className="absolute inset-0 flex items-center justify-center">
          <img
            src="/logo.png"
            alt=""
            aria-hidden="true"
            className="w-1/2 max-w-[260px] opacity-15"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </div>
        {/* Gold ruled line */}
        <div className="absolute bottom-0 left-0 right-0 h-1 bg-[#D4A437]" />
        {children}
      </div>
    );
  }

  if (variant === "stripes") {
    return (
      <div className={`relative w-full h-full bg-[#003B5C] overflow-hidden ${className}`}>
        <div className="absolute inset-0 opacity-[0.07]" style={{
          backgroundImage: "repeating-linear-gradient(45deg, #FFFFFF 0 1px, transparent 1px 32px)",
        }} />
        <div className="absolute top-1/4 -right-10 w-32 h-32 bg-[#D4A437]/20 rounded-sm rotate-12" />
        <div className="absolute bottom-1/4 -left-10 w-24 h-24 bg-[#D4A437]/15 rounded-sm -rotate-12" />
        {children}
      </div>
    );
  }

  if (variant === "monogram") {
    return (
      <div className={`relative w-full h-full bg-[#003B5C] overflow-hidden grain-overlay ${className}`}>
        <div className="absolute inset-0 flex items-center justify-center text-center px-8">
          <div>
            <div className="text-[10px] sm:text-xs uppercase tracking-[0.3em] text-[#D4A437] font-bold mb-3">
              Garland Ebenezer
            </div>
            <div className="font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl leading-none tracking-tighter">
              Seventh-day
              <br />
              Adventist
            </div>
            <div className="mt-2 text-[10px] sm:text-xs uppercase tracking-[0.3em] text-white/60 font-bold">
              Ghanaian Church
            </div>
            <div className="w-12 h-[3px] bg-[#D4A437] mx-auto mt-5" />
          </div>
        </div>
        {children}
      </div>
    );
  }

  return null;
};
